export const fast_preview = {
  LIST: {
    TITLE: "Fast preview",
    TEMPLATE_NAME: "Template name",
    TEMPLATE_CODE: "Template code",
    CODE: "Code",
    ACTIONS: "Actions"
  },
  DETAILS: {
    TITLE: "Document fast preview configuration",
    TEMPLATE_CODE: "Template code",
    TEMPLATE_NAME: "Template name",
    PREVIEW_FORM_FIELDS: "Preview form fields",
    SELECT_ALL: "Select all",
    DOCUMENT_DATA: "Document data",
    FAST_PREVIEW_FEATURE_TYPES: "Fast preview feature types",
    FIELDS: {
      PARTY: "Party",
      GOODS: "Goods",
      CONTAINERS: "Containers",
      TRANSPORT: "Transport",
      SHIPPING_INSTRUCTIONS: "Shipping instructions",
      BOOKINGS: "Bookings",
      BL_NUMBERS: "BL numbers",
      TRANSPORT_STOP: "Transport Stop",
      CUSTOMER_AGENT: "Customer agent",
      CUSTOM_AGENT_PARTY: "Custom agent party",
      CONTACT_PERSON: "Contact Person",
      LANGUAGE: "Language",
    },

    OPTIONAL: "Optional",
    REQUIRED: "Required"
  }
}
